import { render, staticRenderFns } from "./AddSite.vue?vue&type=template&id=2ed38178&scoped=true&"
import script from "./AddSite.vue?vue&type=script&lang=js&"
export * from "./AddSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed38178",
  null
  
)

export default component.exports